// src/hooks/autonomoFactsConfig.js
//
// Configuration and factory for AutonomoFacts — the person-level RETA/
// autónomo status facts, distinct from per-activity IncomeItem facts.
// See calculatorTypes.ts for the shape this must match exactly.
//
// Deliberately facts-only, per the "store facts, derive conclusions"
// discipline established for this feature — no eligibility booleans here.
// registered_reta_last_2_years is the raw fact tarifa plana eligibility is
// derived from in autonomoSession.ts; it is NOT "tarifa_plana_eligible".

export const AUTONOMO_TYPE_OPTIONS = [
  { value: 'individual', label: 'Individual (autónomo persona física)' },
  { value: 'societario',  label: 'Through a company I own (autónomo societario)' },
]

// Generic yes/no option list + mapping helpers for any boolean|null fact.
// Deliberately no 'unsure' option — for both registered_reta_last_2_years
// and previously_used_tarifa_plana, this is a fact about the person's own
// history, not a judgment call; they should know it. (activity_started_this_year
// on IncomeItem, in incomeCardConfig.js, reuses these same helpers.)
// Question wording, defined once: the autónomo form and the Advisor Intake Review (ticket 069) read it.
export const AUTONOMO_QUESTIONS = {
  type: 'Are you operating as an individual, or through a company you own?',
  reta: 'Were you registered in RETA (Seguridad Social for autónomos) at any point in the last 2 years?',
  tarifa: 'Had you used the flat-rate contribution (tarifa plana) yourself at any earlier point?',
}

export const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no',  label: 'No' },
]

export function boolToOptionValue(flag) {
  if (flag === true) return 'yes'
  if (flag === false) return 'no'
  return ''
}

export function optionValueToBool(value) {
  if (value === 'yes') return true
  if (value === 'no') return false
  return null
}

export function createEmptyAutonomoFacts() {
  return {
    is_autonomo: true,   // implicit for anyone in this journey — not asked as a question
    autonomo_type: 'individual',
    current_contribution_base: null,
    selected_contribution_base: null,   // v1a: always null — engine defaults to band minimum, no base-picker UI yet
    registered_reta_last_2_years: null,
    previously_used_tarifa_plana: null,   // only asked/meaningful once registered_reta_last_2_years resolves to false
  }
}